module.exports = __webpack_public_path__ + "fonts/CircularStd-Black.49611f29.woff";